// extracted by mini-css-extract-plugin
var _1 = "ra-artist-list-arts";
var _2 = "ra-artist-list-arts-col";
export { _1 as "artistListArtsCls", _2 as "artistListArtsColCls" }
